<template>
    <div v-if="showConsent" class="cookie-consent-container">
        <div class="cookie-consent">
            <p class="cookie-consent-text">
                We and third party companies use cookies on this website to enhance your user experience, to serve targeted advertisement,
                <br>and to measure the audience of our website. See our  for more information.
                <router-link :to="{name: 'PrivacyPolicy'}" class="cookie-link">Privacy Policy</router-link>
            </p>
        </div>
        <div class="cookie-buttons-container">
            <div class="cookie-buttons">
                <button class="reject-button" @click="showConsent = false">Reject All Cookies</button>
                <button class="accept-button" @click="acceptCookies">Accept All Cookies</button>
            </div>
        </div>
        <div class="close-button-container">
            <button class="close-button" @click="showConsent = false">×</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ApiRouter from "@/components/Systems/ApiRouter.vue";

export default {
    name: "CookieConsent",
    mixins: [ApiRouter],
    data() {
        return {
            showConsent: false,
            errorMessage: '',
        }
    },
    mounted() {
        this.checkCookieConsent();
    },
    methods: {
        async checkCookieConsent() {
            try {
                const response = await axios.get(this.routes.cookie);
                this.showConsent = response.data.showConsent;
                if (!this.showConsent) {
                    this.loadGA();
                }
            } catch (error) {
                this.errorMessage = 'cookie同意確認に失敗しました。';
            }
        },
        async acceptCookies() {
            try {
                const response = await axios.post(this.routes.cookie);
                if (response.data.showConsent) {
                    this.loadGA();
                    this.showConsent = false;
                }
            } catch (error) {
                this.errorMessage = 'cookieの設定に失敗しました。';
            }
        },
        loadGA() {
            if (document.getElementById('ga-script')) return;

            const script = document.createElement('script');
            script.id = 'ga-script';
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=G-456P7BLQQ3";
            document.head.appendChild(script);

            script.onload = () => {
                window.dataLayer = window.dataLayer || [];
                function gtag(){ window.dataLayer.push(arguments); }
                gtag('js', new Date());
                gtag('config', 'G-456P7BLQQ3');
            };
        }
    }
}
</script>

<style src="./CookieConsent.scss" lang="scss" scoped />
